import { createFileRoute } from "@tanstack/react-router";
import AdminCollectionNewPage from "@/pages/admin/lms/collections/new";
import { useLmsPermissions } from "@/pages/admin/lms";

export const Route = createFileRoute("/app/admin/lms/collections/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { userCanEditAllMaterials, userCanViewAllMaterials } = useLmsPermissions();

  return (
    <AdminCollectionNewPage
      userCanEditAllMaterials={userCanEditAllMaterials}
      userCanViewAllMaterials={userCanViewAllMaterials}
    />
  );
}
